import { removeLeadingZero } from '../../../utils/formaters';

export const formatPrice = (value: string | number) => {
  const price = removeLeadingZero(value.toString());

  return price.replace(/\d(?=(?:\d{3})+$)/g, match => `${match} `);
};
